import { getCookieValue } from '../cookie';

/**
 * Read QueryParams and set Data
 * @param {*} data - Data Object
 * @param {URLSearchParams} urlParams - URL Params
 */
function readQueryParams(data, urlParams) {
  if (urlParams.has('trans')) {
    data.offer_id = urlParams.get('off');
    data.click_id = urlParams.get('trans');
    data.partner_id = urlParams.get('ref');
    data.referrer = 'techfiliateAffiliate';
    data.target = 'techfiliate';
  } else if (urlParams.has('irclickid') || urlParams.has('mpid')) {
    data.click_id = urlParams.get('irclickid');
    data.affiliate_id = urlParams.get('mpid');
    data.referrer = 'impactAffiliate';
    data.target = 'impact';
  } else if (urlParams.has('ref')) {
    data.partner_id = urlParams.get('ref');
    data.target = 'affiliate';
    data.source = 'backlink';
    data.referrer = 'affiliate';
  } else if (urlParams.has('sscid')) {
    data.source = 'backlink';
    data.partner_id = '0e741fd8-43f7-4f4d-9740-a8498bead408';
    data.target = 'shareasale';
    data.sscid = urlParams.get('sscid');
    data.referrer = 'shareasaleAffiliate';
  } else if (
    urlParams.has('utm_medium') &&
    urlParams.get('utm_medium') === 'cpc'
  ) {
    data.referrer = urlParams.get('utm_source');
    data.keyword = urlParams.get('keyword');
    data.adset_name = urlParams.get('adset_name');
    data.ad_name = urlParams.get('ad_name');
    data.campaign_name = urlParams.get('utm_campaign');
    data.utm_content = urlParams.get('utm_content');
    data.utm_term = urlParams.get('utm_term');
    data.utm_medium = urlParams.get('utm_medium');
    if (
      urlParams.has('utm_source') &&
      urlParams.get('utm_source') === 'google'
    ) {
      data.referrer = 'SEM';
    } else if (
      urlParams.has('utm_source') &&
      urlParams.get('utm_source') === 'gdn'
    ) {
      data.referrer = 'GDN';
      data.keyword = true;
      data.matchtype = true;
    } else if (
      urlParams.has('utm_source') &&
      urlParams.get('utm_source') === 'facebook'
    ) {
      data.referrer = 'FACEBOOK';
      data.keyword = true;
    } else if (
      urlParams.has('utm_source') &&
      urlParams.get('utm_source') === 'bing'
    ) {
      data.referrer = 'BING';
    }
  } else if (
    urlParams.has('utm_source') &&
    urlParams.get('utm_source') === 'youtube' &&
    urlParams.get('utm_medium') === 'cpv'
  ) {
    data.referrer = 'YOUTUBE';
  } else if (urlParams.has('referrer')) {
    data.referrer = urlParams.get('referrer');
  }
}

/**
 *
 * @param {*} data - Data Payload
 * @param {string} domain - Domain
 */
function checkParameters(data, domain) {
  data.referrer = 'website';
  if (domain === 'landingPage') {
    data.landing_page = window.location.href;
  }
  let urlParameters;
  const params = getCookieValue(window.btoa('query_params'));
  if (params) {
    urlParameters = new URLSearchParams(params);
  } else {
    const searchUrl = window.location.search.split('?');
    urlParameters = new URLSearchParams(searchUrl[1]);
  }
  data['amp_event_property'] = {};
  data['amp_user_property'] = {};

  const novSettingVariant = sessionStorage.getItem('nov-setting-2');
  const noLoginVariant = sessionStorage.getItem('no-login-exp');

  if (novSettingVariant) {
    data['amp_event_property']['Nov Setting V2'] = novSettingVariant;
    data['amp_user_property']['Nov Setting V2'] = novSettingVariant;
  }

  if (noLoginVariant) {
    data['amp_user_property']['No Login Experiment'] = noLoginVariant;
  }

  if (
    urlParameters.has('ref') ||
    urlParameters.has('sscid') ||
    urlParameters.has('fbclid') ||
    urlParameters.has('utm_source') ||
    urlParameters.has('gclid') ||
    urlParameters.has('irclickid') ||
    urlParameters.has('referrer') ||
    urlParameters.has('mpid') ||
    urlParameters.has('msclkid')
  ) {
    readQueryParams(data, urlParameters);
  }

  /**
   * This code is required for signups from /register page
   * They are driven by appsumo and come with coupon code in query params.
   * This coupon is validated at backend and user is upgraded to PROFESSIONAL plan
   */
  if (
    window.location.href.includes('coupon=') &&
    window.location.href.includes('/register')
  ) {
    const searchUrl = window.location.search.split('?');
    urlParameters = new URLSearchParams(searchUrl[1]);
    data.coupon = urlParameters.get('coupon');
  }
}

export { checkParameters };
